import gql from "graphql-tag";
import { FeedConnection } from "./_common.js";
import { IImagePreview } from "./gallery.js";
import { imagePreview } from "./fragments.js";
import { Partner } from "./about.js";
import { News, NewsContent } from "./news.js";
import type { LangCode } from "../../../_common/types.js";
import { GameForCard, gamePreview } from "./games/_common.js";

export interface GetHomeContentVariables {
    langCode?: LangCode;
    first: number;
    reviewsFirst: number;
}

export interface HomePageContent {
    title: string;
    metaDescription: string;
    keywords?: string;
    welcomeSecTitle: string;
    welcomeSecText: string;
    skyMapSecTitle: string;
    skyMapSecText: string;
    simpleSecTitle: string;
    simpleSecText: string;
    newsSecTitle: string;
    newsSecText: string;
    extensiveSecTitle: string;
    extensiveSecText: string;
    observingSecTitle: string;
    observingSecText: string;
    customizedSecTitle: string;
    customizedSecText: string;
    arSecTitle: string;
    arSecText: string;
    timeSecTitle: string;
    timeSecText: string;
    toolsSecTitle: string;
    toolsSecText: string;
    reviewSecTitle: string;
    partnersSecTitle: string;
    quizSecTitle: string;
    quizSecText: string;
    quizSecBtn: string;
}
// type ImageForFeed = Pick<Image, "id" | "content">;

type NewsContentForHome = Pick<NewsContent, "title">;

export type NewsItemForHome = Pick<
    News<NewsContentForHome, IImagePreview>,
    "id" | "content" | "date" | "featured" | "image"
>;
export interface Review {
    author: string;
    quote: string;
    url: string | null;
}
interface Product {
    id: string;
    reviews: Review[] | null;
}

export interface GetHomeContentData {
    homePage: {
        id: string;
        content: HomePageContent;
        promoItems: GameForCard[] | null;
    };
    newsFeed: Pick<FeedConnection<NewsItemForHome>, "edges"> | null;
    partners: Partner[] | null;
    product: Product | null;
}

export const GET_HOME_CONTENT = gql`
    query getHomeContent($langCode: LangCode, $first: Int, $reviewsFirst: Int) {
        homePage: staticContent(id: "sw-site-home") {
            id
            content(langCode: $langCode)
            promoItems {
                ...gamePreview
            }
        }
        newsFeed(first: $first) {
            edges {
                node {
                    id
                    date
                    featured
                    content(langCode: $langCode) {
                        title
                    }
                    image {
                        ...imagePreview
                    }
                }
            }
        }
        partners {
            id
            content {
                name
            }
            url
            imageUrl
        }
        product(id: "star-walk-2") {
            id
            reviews(langCode: $langCode, first: $reviewsFirst) {
                id
                quote
                author
                url
            }
        }
    }
    ${imagePreview}
    ${gamePreview}
`;
